import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import './quickFacts.scss';

const QuickFacts = ({ facts, factsHeader }) => {
  return (
    <div className="gw-cruise-ship-quick-facts-container">
      <div className="gw-cruise-ship-quick-facts-heading">{factsHeader}</div>
      <ul className="gw-cruise-ship-quick-facts">
        {facts.map((fact) => {
          return (
            <li
              key={uniqid('cruise-ship-quick-fact-')}
              className="gw-cruise-ship-quick-fact"
            >
              <div className="gw-cruise-ship-quick-fact__title">{`${fact.factName}:`}</div>
              <div className="gw-cruise-ship-quick-fact__value">
                {fact.factValue}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

QuickFacts.propTypes = {
  facts: PropTypes.arrayOf(
    PropTypes.shape({
      sortOrder: PropTypes.number,
      factValue: PropTypes.string,
      factName: PropTypes.string,
    }),
  ).isRequired,
  factsHeader: PropTypes.string.isRequired,
};

export default QuickFacts;
